<template>
  <section v-show="sidebarCurrentPanel === 'types'"  class="kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open">
    <div class="kp-modular-tab pt-page no-fade pt-page-current">
      <header class="kp-modular-title">{{ $t('general.labels.themes') }}</header>
      <div class="submenu-content sub-color">
        <type-header></type-header>
        <type-popup></type-popup>
        <type-fullscreen></type-fullscreen>
        <type-component></type-component>
        <type-slider></type-slider>
        <type-mini-slide></type-mini-slide>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import TypeHeader from './Header';
import TypePopup from './items/Popup';
import TypeFullscreen from './items/Fullscreen';
import TypeComponent from './items/Component';
import TypeSlider from './items/Slider';
import TypeMiniSlide from './items/MiniSlide';

export default {
  components: {
    TypeHeader,
    TypePopup,
    TypeFullscreen,
    TypeComponent,
    TypeSlider,
    TypeMiniSlide,
  },
  computed: mapGetters({
    sidebarCurrentPanel: 'sidebarCurrentPanel',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?a76bfb60
 **/